import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const profileRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROFILE,
    name: 'PROFILE',
    component: () => import('./ProfilePage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.SETTINGS,
    name: 'SETTINGS',
    component: () => import('./SettingsPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: routes.DOCUMENT_PREVIEW,
    name: 'DOCUMENT_PREVIEW',
    component: () => import('./DocumentPreviewPage.vue'),
    meta: { requiresAuth: true },
  },
]
